import { AlertType, CompType } from '@aloft/toolkit-shared';

export type AlertCompType = CompType;

export const getCompTypeLabel = (compType: AlertCompType): string =>
  compType === 'aiv' ? 'AIV' : 'ARV';

export const getCompTypeComparableLabel = (compType: AlertCompType): string =>
  compType === 'aiv' ? 'As-Is' : 'After-Repair';

export const getScopedAlertType = (base: string, compType?: AlertCompType): AlertType =>
  (compType ? `${base}${compType === 'aiv' ? 'Aiv' : 'Arv'}` : base) as AlertType;

export const getComparableDisplayName = (propertyID: string): string => {
  const match = /^comp(\d+)$/.exec(propertyID);
  return match ? `Comparable ${match[1]}` : propertyID;
};
